import { z } from 'zod';
import { flag, str } from '../../navigation/searchParams';

/** Whether the live list refreshes itself, and the call being watched. */
export const audioMonitorSearch = z.object({
  auto: flag,
  call: str,
});
